@if (isPointCloudOutputSelected$ | async) {
  <h3-main-point-cloud-toolbar></h3-main-point-cloud-toolbar>
  <h3-point-cloud-secondary-toolbar></h3-point-cloud-secondary-toolbar>
}
@if (is2dOutputSelected$ | async) {
  <h3-main-video-toolbar
    [videoOutputName]="videoOutputName$ | async"
  ></h3-main-video-toolbar>
  <h3-secondary-toolbar-2d
    [videoOutputName]="videoOutputName$ | async"
  ></h3-secondary-toolbar-2d>
}
<div class="right-toolbar">
  <h3-settings></h3-settings>
  <h3-reset-sensor-view-button></h3-reset-sensor-view-button>
  <h3-enhanced-point-cloud-button></h3-enhanced-point-cloud-button>
  @if (showProjectionSettings$ | async) {
    <h3-toggle-point-cloud-projection-button></h3-toggle-point-cloud-projection-button>
    <h3-toggle-shape-projection-button></h3-toggle-shape-projection-button>
  }
  <h3-toggle-zoom-panel></h3-toggle-zoom-panel>
  <h3-inspect-button></h3-inspect-button>
  @if (shouldShowCalibrationSettings$ | async) {
    <h3-calibration-settings-button
      [injector]="pointCloudInjector$ | async"
      [videoOutputName]="videoOutputName$ | async"
    ></h3-calibration-settings-button>
  }
  <h3-toggle-view-modes-button></h3-toggle-view-modes-button>
  @if (isSplitViewEnabled) {
    <h3-toggle-split-view-button></h3-toggle-split-view-button>
  }
  <h3-cv-help-modal-button></h3-cv-help-modal-button>
  <h3-show-feedback-button></h3-show-feedback-button>
</div>
